import React from "react";
import { Modal, Button } from "flowbite-react";

const DeleteModal = ({ entityId, show, onDelete, onClose, message }) => {
  return (
    <div className="container z-50">
      <Modal
        show={show}
        onClose={() => {
          onClose();
        }}
      >
        <Modal.Header>Delete Confirmation</Modal.Header>
        <Modal.Body className="items-center justify-center dark:text-white">
          <p>{message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button color="failure" onClick={() => onDelete(entityId)}>
            Delete
          </Button>
          <Button color="light" onClick={onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeleteModal;
